module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_null.6b16ee91.png";